import React from 'react'

const TrackingVasIcon = () => {
    return (
        <>
            <svg
                width={390}
                height={512}
                viewBox="0 0 390 512"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="card-svg"
            >
                <path
                    d="M195 0V512C200.116 512 204.637 509.503 207.45 505.674C207.471 505.674 351.723 308.872 351.723 308.872C375.266 276.734 389.189 237.09 389.189 194.189C389.189 86.9411 302.248 0 195 0Z"
                    fill="#1975C9"
                />
                <path
                    d="M195 0C87.7516 0 0.810547 86.9411 0.810547 194.189C0.810547 237.09 14.7334 276.734 38.2916 308.871C38.2751 308.871 182.528 505.673 182.528 505.673C185.362 509.503 189.884 511.999 195 511.999C199.302 511.999 203.103 509.502 205.468 505.673C205.486 505.673 326.781 308.871 326.781 308.871C346.576 276.734 358.283 237.09 358.283 194.189C358.283 86.9411 285.179 0 195 0Z"
                    fill="#60A9EB"
                />
                <path
                    d="M195 357.474C285.18 357.474 358.284 284.369 358.284 194.19C358.284 104.011 285.18 30.9062 195 30.9062C104.821 30.9062 31.7168 104.011 31.7168 194.19C31.7168 284.369 104.821 357.474 195 357.474Z"
                    fill="#E5F9FF"
                />
                <path
                    d="M81.3967 128.601C80.7169 129.773 80.3597 131.105 80.3613 132.461V255.918C80.3614 257.274 80.7184 258.606 81.3965 259.781C82.0746 260.955 83.05 261.93 84.2245 262.609L191.137 324.337C192.311 325.016 193.644 325.373 195 325.372L278.733 128L81.3967 128.601Z"
                    fill="#FF9457"
                />
                <path
                    d="M308.603 128.601L194.994 128L278.731 278.221L305.774 262.609C306.948 261.93 307.923 260.955 308.601 259.78C309.279 258.606 309.637 257.274 309.637 255.918V132.461C309.639 131.105 309.282 129.773 308.603 128.601Z"
                    fill="#FF6145"
                />
                <path
                    d="M278.733 145.843L195 128V325.372C196.334 325.372 197.668 325.027 198.863 324.337L278.733 278.221V242.536L263.28 224.692L278.733 206.848V145.843Z"
                    fill="#FF7E4F"
                />
                <path
                    d="M278.736 206.85L225.904 237.352V273.039L278.736 242.536V206.85Z"
                    fill="white"
                />
                <path
                    d="M305.775 125.77L198.862 64.0412C197.688 63.3629 196.355 63.0059 194.999 63.0059C193.643 63.0059 192.31 63.3629 191.136 64.0412L137.68 94.9002L153.132 161.1H252.318L308.602 128.601C307.925 127.425 306.95 126.449 305.775 125.77Z"
                    fill="#FF9457"
                />
                <path
                    d="M137.68 94.9004L84.2224 125.77C83.0479 126.449 82.0727 127.425 81.3945 128.601L194.999 194.189L252.318 161.1L137.68 94.9004Z"
                    fill="#FFAE6B"
                />
            </svg>

        </>
    )
}

export default TrackingVasIcon